export interface ImageThumbnails {
  small: string;
  medium: string;
  large: string;
}

export interface Image {
  id: string;
  thumbnailUrls: ImageThumbnails;
  originalUrl: string;
  isPrimary: boolean;
  is360: boolean;
  latitude?: number;
  longitude?: number;
  name?: string;
}

export class ParsedRecord {
  PEAK_ID: string;
  STATE_CODE: string;
  STATE: string;
  NAME: string;
  ELEVATION: number;
  RANGE: string | null;
  PROMINENCE: number | null;
  LATITUDE: number;
  LONGITUDE: number;
  CAR: boolean | null;
  MARTIN_DIFFICULTY: number | null;
  HIKING_TRAIL: string | null;
  HIKING_GPX: string | null;
  HIKING_DISTANCE: number | null;
  HIKING_GAIN: number | null;
  HIKING_TIME: number | null;
  SCHEDULED_DATE: Date | null;
  SUMMIT_DATE: Date | null;
  PERMITS_AND_RESTRICTIONS: string | null;
  SPECIAL_EQUIPMENT: string | null;
  BLOG_TEXT: string | null;
  IMAGES: Image[];

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(data: any, imgRecords: any) {
    this.PEAK_ID = data.fields.PEAK_ID;
    this.STATE_CODE = data.fields.STATE_CODE;
    this.STATE = data.fields.STATE;
    this.NAME = data.fields.NAME;
    this.ELEVATION = data.fields.ELEVATION;
    this.RANGE = data.fields.RANGE;
    this.PROMINENCE = data.fields.PROMINENCE;
    this.LATITUDE = data.fields.LATITUDE;
    this.LONGITUDE = data.fields.LONGITUDE;
    this.CAR = data.fields.CAR;
    this.MARTIN_DIFFICULTY = data.fields.MARTIN_DIFFICULTY;
    this.HIKING_TRAIL = data.fields.HIKING_TRAIL;
    this.HIKING_GPX = data.fields.HIKING_GPX?.[0].url;
    this.HIKING_DISTANCE =
      data.fields.HIKING_DISTANCE === undefined
        ? null
        : data.fields.HIKING_DISTANCE;
    this.HIKING_GAIN =
      data.fields.HIKING_GAIN === undefined ? null : data.fields.HIKING_GAIN;
    this.HIKING_TIME =
      data.fields.HIKING_TIME === undefined ? null : data.fields.HIKING_TIME;
    this.SCHEDULED_DATE = data.fields.SCHEDULED_DATE
      ? new Date(data.fields.SCHEDULED_DATE)
      : null;
    this.SUMMIT_DATE = data.fields.SUMMIT_DATE
      ? new Date(data.fields.SUMMIT_DATE)
      : null;
    this.PERMITS_AND_RESTRICTIONS = data.fields.PERMITS_AND_RESTRICTIONS;
    this.SPECIAL_EQUIPMENT = data.fields.SPECIAL_EQUIPMENT;
    this.BLOG_TEXT = data.fields.BLOG_TEXT;
    this.IMAGES = this._parseImages(data.fields.IMAGES, imgRecords);
  }

  private _parseImages(recordIds: string[], imgRecords: any) {
    return (
      recordIds?.map((recordId) => {
        const imgRecord = imgRecords.find(
          (record: any) => record.id === recordId
        );
        const imgData: Image = {
          id: imgRecord.fields.IMAGE[0].id,
          originalUrl: imgRecord.fields.IMAGE[0].url,
          thumbnailUrls: {
            small: imgRecord.fields.IMAGE[0].thumbnails.small.url,
            medium: imgRecord.fields.IMAGE[0].thumbnails.large.url,
            large: imgRecord.fields.IMAGE[0].thumbnails.full.url
          },
          name: imgRecord.fields.IMAGE[0].filename,
          latitude: imgRecord.fields.LATITUDE,
          longitude: imgRecord.fields.LONGITUDE,
          isPrimary: imgRecord.fields.IS_PRIMARY || false,
          is360: imgRecord.fields.IS_360 || false
        };
        return imgData;
      }) || []
    );
  }
}
